import React from 'react';
/**
 * `ButtonContinue` is a thin styled wrapper around the shared `Button`
 * component.
 *
 * It applies the base "primary" button classes plus the `cms-btn-continue` CMS
 * hook class, and forwards all behaviour (disabled/waiting/click handling) to
 * `Button`.
 */
import Button from './Button';

type ButtonContinueProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
};

export const ButtonContinue = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames
}: ButtonContinueProps): JSX.Element => {
  let classes = 'button button-basic';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-continue';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
    />
  );
};
